export default {
  display: 'inline-block',
  '&.flex': {
    display: 'inline-flex'
  },
  '&.fullWidth': {
    width: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/styles/buttons/container.js